import React from 'react'
import { DayPickerSingleDateController } from 'react-dates'
import Modal from 'react-modal'

import snoozePerson from '../../actions/snoozePerson'
import unsnoozePerson from '../../actions/unsnoozePerson'

const SnoozeDatePicker = ({match, history}) => (
  <Modal
    isOpen={true}
    onRequestClose={() => history.goBack()}
  >
    <h2>Snooze until...</h2>
    <DayPickerSingleDateController
      hideKeyboardShortcutsPanel={true}
      noBorder={true}
      onDateChange={date => {
        snoozePerson(match.params.personId, date.toDate())
          .then( () => history.goBack())
      }}
    />
    <button onClick={() => unsnoozePerson(match.params.personId)}>don't snooze</button>
  </Modal>
)

export default SnoozeDatePicker



// WEBPACK FOOTER //
// ./src/views/people/SnoozeDatePicker.js